import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkUpdateInventoryItemsRequest = {};
var _bulkUpdateInventoryItemsResponse = {};
var _bulkUpdateInventoryVariantsRequest = {};
var _bulkUpdateInventoryVariantsResponse = {};
var _decrementInventoryRequest = {};
var _decrementInventoryResponse = {};
var _getInventoryVariantsRequest = {};
var _getInventoryVariantsResponse = { inventoryItem: '_inventoryItemV2' };
var _incrementInventoryRequest = {};
var _incrementInventoryResponse = {};
var _inventoryItemV2 = { lastUpdated: 'google.protobuf.Timestamp' };
var _queryInventoryRequest = {};
var _queryInventoryResponse = { inventoryItems: '_inventoryItemV2' };
var _updateInventoryVariantsRequest = { inventoryItem: '_inventoryItemV2' };
var _updateInventoryVariantsResponse = {};
function resolveWixInventoryApiV1InventoryWriteApiUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/wix-ecommerce-catalog-web',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/catalog-server',
                destPath: '',
            },
            {
                srcPath: '/wix-ecommerce-catalog',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/catalog-server',
                destPath: '',
            },
        ],
        'ecom._base_domain_': [
            {
                srcPath: '/_api/catalog-server',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/catalog-server',
                destPath: '',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/catalog-server',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/stores/v1/collections',
                destPath: '/v1/collections',
            },
            {
                srcPath: '/stores/v1/products',
                destPath: '/v1/products',
            },
            {
                srcPath: '/stores/v1/inventoryItems',
                destPath: '/v1/inventoryItems',
            },
            {
                srcPath: '/stores/v2/inventoryItems',
                destPath: '/v2/inventoryItems',
            },
            {
                srcPath: '/stores/v1/variants',
                destPath: '/v1/variants',
            },
            {
                srcPath: '/stores/v1/bulk/products',
                destPath: '/v1/bulk/products',
            },
            {
                srcPath: '/stores/v1/products-digital',
                destPath: '/v1/products-digital',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/wix-ecommerce-catalog',
                destPath: '',
            },
            {
                srcPath: '/_api/catalog-server',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/catalog-server',
                destPath: '',
            },
        ],
        'www.wixgateway.com': [
            {
                srcPath: '/stores/v1/products',
                destPath: '/v1/products',
            },
            {
                srcPath: '/stores/v1/collections',
                destPath: '/v1/collections',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/catalog-server',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/catalog-server',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/catalog-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixInventoryApiV1InventoryReadApiUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/wix-ecommerce-catalog-reader-web',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/wix-ecommerce-catalog-reader-web',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/stores-reader/v2/collections',
                destPath: '/v2/collections',
            },
            {
                srcPath: '/stores-reader/v2/inventoryItems',
                destPath: '/v2/inventoryItems',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/wix-ecommerce-catalog-reader-web',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/wix-ecommerce-catalog-reader-web',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/wix-ecommerce-catalog-reader-web',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/wix-ecommerce-catalog-reader-web',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/stores-reader/v2/inventoryItems',
                destPath: '/v2/inventoryItems',
            },
            {
                srcPath: '/stores-reader/v2/collections',
                destPath: '/v2/collections',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function getInventoryVariants(payload) {
    var _a = serializer(_getInventoryVariantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getInventoryVariantsResponse, {
        _inventoryItemV2: _inventoryItemV2,
    }).fromJSON;
    function __getInventoryVariants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.inventory',
            method: 'POST',
            methodFqn: 'wix.inventory.api.v1.InventoryReadApi.GetInventoryVariants',
            url: resolveWixInventoryApiV1InventoryReadApiUrl({
                protoPath: '/v2/inventoryItems/{inventoryId}/getVariants',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getInventoryVariants.fromReq = fromReq;
    __getInventoryVariants.__isAmbassador = true;
    return __getInventoryVariants;
}
/**
 * Returns a list of up inventory items, given the provided paging, sorting and filtering.
 * See [Stores Pagination](https://dev.wix.com/api/rest/wix-stores/pagination) for more information.
 */
export function queryInventory(payload) {
    var _a = serializer(_queryInventoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryInventoryResponse, {
        _inventoryItemV2: _inventoryItemV2,
    }).fromJSON;
    function __queryInventory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.inventory',
            method: 'POST',
            methodFqn: 'wix.inventory.api.v1.InventoryReadApi.QueryInventory',
            url: resolveWixInventoryApiV1InventoryReadApiUrl({
                protoPath: '/v2/inventoryItems/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryInventory.fromReq = fromReq;
    __queryInventory.__isAmbassador = true;
    return __queryInventory;
}
/** Updates product inventory, including total quantity, whether the product is in stock, and whether the product inventory is tracked. */
export function updateInventoryVariants(payload) {
    var _a = serializer(_updateInventoryVariantsRequest, { _inventoryItemV2: _inventoryItemV2 }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateInventoryVariantsResponse, {}).fromJSON;
    function __updateInventoryVariants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.inventory',
            method: 'PATCH',
            methodFqn: 'wix.inventory.api.v1.InventoryWriteApi.UpdateInventoryVariants',
            url: resolveWixInventoryApiV1InventoryWriteApiUrl({
                protoPath: '/v2/inventoryItems/product/{inventoryItem.productId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateInventoryVariants.fromReq = fromReq;
    __updateInventoryVariants.__isAmbassador = true;
    return __updateInventoryVariants;
}
/** Updates variants in bulk by filter, including total quantity, whether the product is in stock, and whether the product inventory is tracked. */
export function bulkUpdateInventoryVariants(payload) {
    var _a = serializer(_bulkUpdateInventoryVariantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateInventoryVariantsResponse, {}).fromJSON;
    function __bulkUpdateInventoryVariants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.inventory',
            method: 'PATCH',
            methodFqn: 'wix.inventory.api.v1.InventoryWriteApi.BulkUpdateInventoryVariants',
            url: resolveWixInventoryApiV1InventoryWriteApiUrl({
                protoPath: '/v2/inventoryItems/variants/bulk-update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateInventoryVariants.fromReq = fromReq;
    __bulkUpdateInventoryVariants.__isAmbassador = true;
    return __bulkUpdateInventoryVariants;
}
/** Updates inventory tracking method in bulk by filter. */
export function bulkUpdateInventoryItems(payload) {
    var _a = serializer(_bulkUpdateInventoryItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateInventoryItemsResponse, {}).fromJSON;
    function __bulkUpdateInventoryItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.inventory',
            method: 'PATCH',
            methodFqn: 'wix.inventory.api.v1.InventoryWriteApi.BulkUpdateInventoryItems',
            url: resolveWixInventoryApiV1InventoryWriteApiUrl({
                protoPath: '/v2/inventoryItems/bulk-update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateInventoryItems.fromReq = fromReq;
    __bulkUpdateInventoryItems.__isAmbassador = true;
    return __bulkUpdateInventoryItems;
}
/** Subtracts a set number of items from inventory. */
export function decrementInventory(payload) {
    var _a = serializer(_decrementInventoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_decrementInventoryResponse, {}).fromJSON;
    function __decrementInventory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.inventory',
            method: 'POST',
            methodFqn: 'wix.inventory.api.v1.InventoryWriteApi.DecrementInventory',
            url: resolveWixInventoryApiV1InventoryWriteApiUrl({
                protoPath: '/v2/inventoryItems/decrement',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __decrementInventory.fromReq = fromReq;
    __decrementInventory.__isAmbassador = true;
    return __decrementInventory;
}
/** Adds a set number of items to inventory. */
export function incrementInventory(payload) {
    var _a = serializer(_incrementInventoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_incrementInventoryResponse, {}).fromJSON;
    function __incrementInventory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v2.inventory',
            method: 'POST',
            methodFqn: 'wix.inventory.api.v1.InventoryWriteApi.IncrementInventory',
            url: resolveWixInventoryApiV1InventoryWriteApiUrl({
                protoPath: '/v2/inventoryItems/increment',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __incrementInventory.fromReq = fromReq;
    __incrementInventory.__isAmbassador = true;
    return __incrementInventory;
}
//# sourceMappingURL=http.impl.js.map